import { useState, useEffect, useContext, useRef } from "react";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, ButtonProps, Tooltip, Card, Input } from "@fluentui/react-components";
import { BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, ArrowMaximize20Regular, DismissSquare24Filled, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, ChatMultipleHeart20Regular, Info20Regular, DesktopPulse20Regular, GroupList20Regular, Dismiss16Regular, Info20Filled, Settings20Regular } from "@fluentui/react-icons";
import { SearchBar } from "../../../components/searchbar/searchbar.component";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { CheckBox } from "../../../components/checkbox/checkbox_component";
import { App_Monitored_Func } from "../../../api/app/app_monitored_func";
import { GlobalContext } from "../../../hooks/globalContext";
import { ToastComponent } from "../../../components/toast/toast.component";
import { Data_Collection_func } from "../../../api/devices/data_collection/data_collection_func";
import { convertToLocalTimezone, convertUTCToHumanReadableFormat, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { fullscreenIcon, lightTheme, primaryIcon, exitIcon, overflowDivider, secondaryIcon, buttonContent, messageTheme, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, heightResponsive, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { shouldLoadRoute } from "../../../Authentication/RouteProtection";
import { usePermissionStore } from "../../../Store/permissionStore";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { Remediation_func } from "../../../api/devices/remediation/remediation_func";
import { InfoBar } from "../../../components/infoBar/infoBar.component";
import { DevicesPages } from "../../../components/side_menu/InlineSidenav";

export const DataCollection = () => {
  const contextValue: any = useContext(GlobalContext);
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const tenantName = contextValue.tenantName;
  const navigate = useNavigate();

  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [overlayName, setOverlayName] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [dropDownValue1, setDropDownValue1] = useState<any>([]);
  const [dropDownValue2, setDropDownValue2] = useState<any>([]);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [isBinaries, setBinaries]: any = useState(false);
  const [exportDetails, setExportDetails]: any = useState([]);
  const [isChecked1, setIsChecked1]: any = useState(false);
  const [deleteAppMonitored, setDeleteAppMonitored]: any = useState(false);
  const [isdeletedisabled, setDeleteDisabled] = useState(true);
  // const [dropDownValue1, setDropDownValue1] = useState<any[]>([]);
  const [deviceName, setDeviceName] = useState('');
  const [monitoredOverLayData, setMonitoredOverLayData]: any = useState([]);
  const [rowID, setRowID]: any = useState(null);
  const [error, seterror] = useState(false);
  const [categorySearchVal, setCategorySearchVal] = useState("");
  const [scoresCpuRequired, setScoreCpuRequired] = useState(false);
  const [scoresMemRequired, setScoreMemRequired] = useState(false);
  const [scoresNetRequired, setScoreNetRequired] = useState(false);
  const [final_data1, set_final_data1]: any = useState(null);
  const [tableData1, setTableData1] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [processName, setProcessname]: any = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [saveBtnClicked1, setSaveBtnClicked1]: any = useState(false);
  const [score, setScore]: any = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [deviceList, setDeviceList]: any = useState(null);
  // const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [selectedOption, setSelectedOption] = useState('');
  const [cloneCpuForms, setCloneCpuForms] = useState([]);
  const [deleteMonitoredApp, setDeleteMonitoredApp]: any = useState(false);
  const [cloneMemForms, setcloneMemForms] = useState<FormMem[]>([])
  const [cloneNetForms, setcloneNetForms] = useState<FormNet[]>([]);
  const [formData, setFormData]: any = useState({ name: '', description: '' });
  const [categorySearchData, setCategorySearchData] = useState(['Business Application', 'Productivity Application', 'Collaboration Tools', 'Developer Tools']);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [recordState, setRecordState]: any = useState(0);
  const [recordTotalPages, setRecordTotalPages]: any = useState(0);
  const [tableColumnsData, setTableColumnsData] = useState([]);
  const [filterColumnsData, setFilterColumnsData] = useState([]);
  const [uniqueCat, setUniqueCat] = useState([]);
  const [columns2, setColumns2] = useState([]);
  const [uniqueStatus, setUniqueStatus] = useState<string[]>([]);
  const [isStatus, setStatus] = useState<any[]>([]);

  useEffect(() => {
    setStatus(uniqueStatus?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
    setColumns2(uniqueCat?.map((item) => ({ key: item, label: <Caption1>{item}</Caption1> })) || []);
  }, [uniqueStatus, uniqueCat])

  const [formDataBasic, setFormDataBasic]: any = useState({
    Category: '',
    Subcategory: '',
    ApplicationName: '',
    ApplicationType: '',
    UrlPatterns: [{ /* urlpattern: '', */ }],
    ApplicationBinaries: '',
    cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
    memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
    netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }]
  });

  const [editformDataBasic, setEditFormDataBasic] = useState({
    Category: '',
    Subcategory: '',
    ApplicationName: '',
    ApplicationType: '',
    UrlPatterns: '',
    ApplicationBinaries: '',
    cpuUtilisation: [{ cpuFrom: '', cpuTo: '', cpuScore: '', cpuRank: '' }],
    memUtilisation: [{ memFrom: '', memTo: '', memScore: '', memRank: '' }],
    netUtilisation: [{ netFrom: '', netTo: '', netScore: '', netRank: '' }]
  }); console.log("Device Name: ", deviceName);

  const buttonref: any = useRef(null);
  const handleOutsideButton = () => { buttonref?.current?.click(); }; // console.log("Date Now: ", Date.now());

  console.log("Form Data: ", formDataBasic);
  console.log("Qwertyuio: ", formDataBasic.memUtilisation);

  const convertedDataCpu = {
    range: formDataBasic.cpuUtilisation.map((item: any) => ({
      cw: "1",
      mw: "1",
      sc: item.cpuScore,
      to: item.cpuTo,
      scw: "1",
      from: item.cpuFrom,
      rank: item.cpuRank,
    })),
  };

  const convertedDataMem = {
    range: formDataBasic.memUtilisation.map((item: any) => ({
      cw: "1",
      mw: "1",
      sc: item.memScore,
      to: item.memTo,
      scw: "1",
      from: item.memFrom,
      rank: item.memRank,
    })),
  };

  const convertedDataNet = {
    range: formDataBasic.netUtilisation.map((item: any) => ({
      cw: "1",
      mw: "1",
      sc: item.netScore,
      to: item.netTo,
      scw: "1",
      from: item.netFrom,
      rank: item.netRank,
    })),
  };

  const convertedDataNetstring = JSON.stringify(convertedDataNet, null, 2)

  console.log("Converted CPU to JSON String: ", convertedDataNetstring);
  useEffect(() => { console.log("Form Data Basic: ", formDataBasic); }, [formDataBasic])

  // const handlewebcheckbox=(e: any) => { setFormDataBasic((prevData: any) => { if(e.target.label == 'web') { if(e.target.checked ) { return{...prevData, ApplicationType: 'Web' } } } else { return{...prevData, ApplicationType: 'Desktop'} } })} 

  const handleWebCheckbox = (e: any) => {
    const isChecked = e.target.checked;
    setFormDataBasic((prevData: any) => {
      if (isChecked) { return { ...prevData, ApplicationType: 'Web', /* Web: true, Desktop: false */ }; }
      else {
        if (!prevData.Desktop) { return { ...prevData, ApplicationType: '', /* Web: false */ }; }
        else { return { ...prevData, /* Web: false */ }; }
      }
    });
  }

  const inputChange = (e: any) => {
    let name = e.target.name;
    const enteredValue = e.target.value;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9_\-. ]*$/;
    const regerxFileAndUrl = /^[A-Za-z0-9-_,\s]+[.]{1}[A-Za-z]{3}$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1 === ("Subcategory") || dropDownValue1 === ("Name")) {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    if (name === 'filter' && dropDownValue1 === ("Url Patterns") || dropDownValue1 === ("Desktop Binaries")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue);
      }
    }
    // if (name === 'filter' && dropDownValue1 === ("Status")) {
    //   if (regexS.test(enteredValue)) {
    //     setDropDownValue2(enteredValue);
    //   }
    // }
  }
  const handleFilterArray = (): any => {
    const value1 = dropDownValue1;
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false)
    } else {
      setResetDisabled(true)
    }
  }, [filterArray])

  const handleDesktopCheckbox = (e: any) => {
    const isChecked = e.target.checked;
    setFormDataBasic((prevData: any) => {
      if (isChecked) { return { ...prevData, ApplicationType: 'Desktop', /* Desktop: true, Web: false */ }; }
      else {
        if (!prevData.Web) { return { ...prevData, ApplicationType: '', /* Desktop: false */ }; }
        else { return { ...prevData, /* Desktop: false */ }; }
      }
    });
  }

  <Stack horizontal tokens={{ childrenGap: 105, padding: 10 }}>
    <StackItem> <Body1> Application Type </Body1> </StackItem>
    <StackItem shrink grow>
      <CheckBox label="Web" checked={formDataBasic.Web} onChange={(e) => handleWebCheckbox(e)} />
      <CheckBox label="Desktop" checked={formDataBasic.Desktop} onChange={(e) => handleDesktopCheckbox(e)} />
    </StackItem>
  </Stack>

  const handleChange = (name: any, val: any) => { // Special handling for multi-select dropdowns (ApplicationType, UrlPatterns, ApplicationBinaries)
    if (name == 'applicationtype') {
      isChecked1 ? setIsChecked1(!isChecked1) : setIsChecked1(!isChecked1)
      console.log("Here check inside: ", isChecked1);
      // Handle multi-select dropdown logic and Assuming your dropdown values are arrays (e.g., ApplicationType: [], UrlPatterns: [])
      // const selectedOptions = Array.from(e.target.selectedOptions, (option: any) => option.value); setFormDataBasic((prevData) => ({ ...prevData, [name]: selectedOptions}));
    } else { setFormDataBasic((prevData: any) => ({ ...prevData, [`${name}`]: val, })); /* Handle regular dropdowns */ }
  };

  const handle = useFullScreenHandle();


  interface FormMem { id: number; data: {}; }
  console.log("Row ID: ", rowID);

  interface FormNet { id: number; data: {}; }

  // const array = options; let options1: any = ['Business Application','Productivity Application','Collaboration Tools','Developer Tools']; const array1 = options; var dropdownData1 = [ { key: "businessapplications", label: <Body1 onClick={() => {handleChange('Subcategory','Business Application');} }> Business Application </Body1> }, { key: "productapplications", label: <Body1 onClick={() => handleChange('Subcategory','Productivity Application')}> Productivity Application </Body1> }, { key: "collaborationtools", label: <Body1 onClick={() => handleChange('Subcategory','Collaboration Tools')}>  Collaboration Tools </Body1> }, { key: "developers", label: <Body1 onClick={() => handleChange('Subcategory','Developer')}> Developer </Body1> }, ]; const dropdownOptions: IDropdownOption[] = [ { key: 'businessapplication', text: 'Business Application' }, { key: 'productapplication', text: 'Productivity Application' }, {key:'collaborationtool', text:'Collaboration Tools'}, {key:'developer',text:'Developer'} ];

  // var columns = [ // data table column name code starts here
  //   { key: "category", label: <Body1Strong > Category </Body1Strong> },
  //   { key: "subcategory", label: <Body1Strong> Subcategory </Body1Strong> },
  //   { key: "name", label: <Body1Strong> Name </Body1Strong> },
  //   { key: "url_pattern", label: <Body1Strong> Url Patterns </Body1Strong> },
  //   { key: "desktop_pattern", label: <Body1Strong>  Desktop Binaries </Body1Strong> },
  //   { key: "status", label: <Body1Strong>  Status </Body1Strong> }
  // ];
  // data table column name code ends here

  // var columns1 = [ // data table column name code starts here
  //   { key: "category", label: <Caption1 > Category </Caption1> },
  //   { key: "subcategory", label: <Caption1> Subcategory </Caption1> },
  //   { key: "name", label: <Caption1> Name </Caption1> },
  //   { key: "url_pattern", label: <Caption1> Url Patterns </Caption1> },
  //   { key: "desktop_pattern", label: <Caption1>  Desktop Binaries </Caption1> },
  //   { key: "status", label: <Caption1>  Status </Caption1> }
  // ];
  var tableColumns: any[] = [];
  var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.Devices?.Data_Collection.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Devices?.Data_Collection.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "Devices", page: "Data_Collection" });
  }, [contextValue.tableColumnsData]);

  var overFlowComponent = { // overflow set contents code starts here
    data:
      <>
        <StackItem>
          <Button disabled={loading} shape="circular" appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <ArrowClockwise20Regular {...(loading?secondaryIcon:primaryIcon)} /> </StackItem>
              <StackItem> <Caption1 > Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        <StackItem>
          {/* <Button shape="circular" appearance="subtle" size="small" onClick={() => {userActivity('Export', `{"summary":"App Monitor List Exported"}`)}}> */}
          {/* <CSVLink id="csv-export-link" data={exportData} filename="appmonitored_list.csv"> 
            <Button shape="circular" appearance="subtle" size="small">
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem> <ArrowDownload20Regular {...primaryIcon}/> </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </CSVLink> */}
          {permissions.includes("all") || permissions.includes("dataCollection_Fullaccess") ?
            <>
              <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_appmonitored_list.csv`}>
              </CSVLink>
              <Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); }}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem> <ArrowDownload20Regular {...(loading || tableData.length === 0?secondaryIcon:primaryIcon)}  /> </StackItem>
                  <StackItem> <Caption1> Export </Caption1> </StackItem>
                </Stack>
              </Button>
            </>
            :
            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
              <Button shape="circular" appearance="subtle" size="small" disabled>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                  <StackItem><Text></Text></StackItem>
                  <StackItem>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                      <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                      <StackItem><Caption1> Export </Caption1></StackItem>
                    </Stack>
                  </StackItem>
                </Stack>
              </Button>
            </Tooltip>
          }

          {/* <StackItem> */}
          <Button disabled={loading || tableData.length === 0} shape="circular" appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> <Settings20Regular {...(loading || tableData.length === 0?secondaryIcon:primaryIcon)}  /> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
          {/* </StackItem> */}

        </StackItem>
        <StackItem grow shrink>
            <Stack horizontalAlign="end">
              <StackItem grow shrink>
                <FullScreenButton handle={handle} />
              </StackItem>
            </Stack>
          </StackItem>
      </>
  }; // overflow set contents code ends here

  useEffect(() => {
    console.log("Category Options: ", dropDownValue1, "Object.keys(categoryData)");
    if (dropDownValue1?.length > 0) { setFormDataBasic({ ...formDataBasic, Category: dropDownValue1[0] }); }
    else { console.log("Cat else"); }
  }, [dropDownValue1]);

  var tempTableData: any = [];

  useEffect(() => {
    var tempExportData: any = [];
    var status = '';

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      if (val.status === undefined || val.status === null || val.status == 'not attached') {
        status = 'Not attached';
      } else {
        var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

        if (curStatus.length == 0) {
          status = 'Not attached';
        } else {
          curStatus = curStatus[0]?.split(":")[1];

          if (curStatus == 'all') {
            status = 'Enabled for All Devices';
          } else {
            status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
          }
        }
      }

      tempExportData.push({
        Category: val.Category,
        'Sub Category': val.subcategory,
        Name: val.MetricDesc,
        'URL Pattern': val.UrlPatters,
        'Desktop Pattern': val.SpecificInfo,
        'Status': status
      });
    });

    setExportBtnClicked(false);
    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
  }, [exportData]);

  useEffect(() => {
    if (final_data !== undefined && final_data !== null && final_data.length > 0) {
      const newUniqueCat: any = [];
      const newUniqueStatus: string[] = [];
      final_data?.forEach((val: any) => {
        if (newUniqueCat.indexOf(val.Category) === -1) {
          newUniqueCat.push(val.Category);
        }
        if (val.status && val.status.trim() !== "-" && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        } else if ((val.status != "not attached" || (val.status == "" || val.status == null)) && !newUniqueStatus.includes(val.status)) {
          newUniqueStatus.push(val.status);
        }
      });
      setUniqueCat(newUniqueCat);
      setUniqueStatus(newUniqueStatus);
    } else {
      setUniqueCat([]);
      setUniqueStatus([]);
    }
  }, [final_data])

  useEffect(() => { // data table values append code starts here
    console.log("final_data1: ", final_data1);
    var status = '';

    if (currentPageNo == 1) {
      final_data1 !== undefined && final_data1 !== null && final_data1?.map((val: any, i: any) => {
        console.log("val.status before value: ", val.status);
        if (val.status === undefined || val.status === null || val.status === 'not attached') {
          console.log("val.status inside value: ", val.status);
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length == 0) {
            status = 'Not attached';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus == 'all') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }

        const categoryLabel = permissions.includes("dataCollection_Read") ? (
          <TooltipHost content="This feature is not available for you!">
            <Button appearance="transparent" size="small"> {val.category} </Button>
          </TooltipHost>
        ) : (
          <Button 
            appearance="transparent"
            size="small"
            id="ButtonHover"
            name="default_dart"
            style={buttonContent}
            onClick={() => {
              localStorage.setItem('automationDetails', JSON.stringify({ automationName: val.automationName, automationType: val.types }));
              contextValue.setAutomationDetails({ ...contextValue.automationDetails, automationName: val.automationName, automationType: val.types });
              contextValue.setDartNo(val.dartid);
              localStorage.setItem('selectedapp', JSON.stringify({
                name: val.automationName,
                rowid: val.id,
                type: 'default_dart'
              }));
              setBinaries(true);
              navigate("/manage/devices/datacollection/assignment");
            }}
          >
            {val.category}
          </Button>
        );
        {
          permissions.includes("all") || permissions.includes("dataCollection_Fullaccess") ?
          tempTableData.push({
            id: val.id,
            checkbox: "hide",
            category: { label: categoryLabel, id: `${i}` },
            subcategory: { label: <Caption1> - </Caption1>, status: "" },
            name: { label: <Caption1> {val.automationName} </Caption1> },
            url_pattern: { label: <Caption1> - </Caption1> },
            desktop_pattern: { label: <Caption1> - </Caption1> },
            attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
            attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
            attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
            attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
            status: { label: <Caption1> {status} </Caption1>, status: "" }
          })
          :
          tempTableData.push({
            id: val.id,
            checkbox: "hide",
            category: {
              label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button appearance="transparent" size="small">  {val.category} </Button>
              </Tooltip>, id: `${i}`
            },
            subcategory: { label: <Caption1> - </Caption1>, status: "" },
            name: { label: <Caption1> {val.automationName} </Caption1> },
            url_pattern: { label: <Caption1> - </Caption1> },
            desktop_pattern: { label: <Caption1> - </Caption1> },
            attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
            attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
            attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
            attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
            status: { label: <Caption1> {status} </Caption1>, status: "" }
          })
        }
      });
    }



    status = '';
    final_data !== undefined && final_data !== null && final_data?.length > 0 //this will  help to give no result.
      && final_data?.map((val: any, i: any) => {

        if (val.status === undefined || val.status === null || val.status === 'not attached') {
          status = 'Not attached';
        } else {
          var curStatus = val.status?.split("|").filter((val: any) => val.includes(`${contextValue.tenantName}:`));

          if (curStatus.length == 0) {
            status = 'Not attached';
          } else {
            curStatus = curStatus[0]?.split(":")[1];

            if (curStatus == 'All Device') {
              status = 'Enabled for All Devices';
            } else {
              status = curStatus?.split(",").length == 1 ? `Enable for ${curStatus?.split(",").length} Device Classification` : `Enable for ${curStatus?.split(",").length} Device Classifications`;
            }
          }
        }

        const categoryLabel = permissions.includes("dataCollection_Read") ? (
          <TooltipHost content="This feature is not available for you!">
            <Button shape="circular" appearance="transparent" size="small"> {val.Category} </Button>
          </TooltipHost>
        ) : (
          <Button shape="circular"
            appearance="transparent"
            size="small"
            id="ButtonHover"
            onClick={() => {
              localStorage.setItem('selectedapp', JSON.stringify({
                name: val.MetricDesc,
                rowid: val.id,
                url_pattern: val.UrlPatters,
                desktop_binaries: val.SpecificInfo,
                type: 'data_collection'
              }));
              localStorage.setItem('automationDetails', JSON.stringify({ automationName: val.MetricDesc, automationType: "data_collection" }));
              contextValue.setAutomationDetails({ ...contextValue.automationDetails, automationName: val.MetricDesc, automationType: "data_collection" })
              setBinaries(true);
              navigate("/manage/devices/datacollection/assignment");
            }}
          >
            {val.Category}
          </Button>
        );
        {
          permissions.includes("all") || permissions.includes("dataCollection_Fullaccess") ?
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              category: {
                label: <Button
                  appearance="transparent"
                  size="small"
                  id="ButtonHover"
                  style={buttonContent}
                  onClick={() => {
                    localStorage.setItem('selectedapp', JSON.stringify({
                      name: val.MetricDesc,
                      rowid: val.id,
                      url_pattern: val.UrlPatters,
                      desktop_binaries: val.SpecificInfo,
                      type: 'data_collection'
                    }));
                    localStorage.setItem('automationDetails', JSON.stringify({ automationName: val.MetricDesc, automationType: "data_collection", id: val.id }));
                    contextValue.setAutomationDetails({ ...contextValue.automationDetails, automationName: val.MetricDesc, automationType: "data_collection", id: val.id })
                    setBinaries(true);
                    navigate("/manage/devices/datacollection/assignment");
                  }}
                >
                  {val.Category}
                </Button>, id: `${i}`
              },
              subcategory: { label: <Caption1> {val.subcategory} </Caption1>, status: "" },
              name: { label: <Caption1> {val.MetricDesc} </Caption1> },
              url_pattern: { label: <Caption1> {val.UrlPatters != null ? val.UrlPatters : "-"} </Caption1> },
              desktop_pattern: { label: <Caption1> {val.SpecificInfo} </Caption1> },
              attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
              attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
              attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
              attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
              status: { label: <Caption1> {status} </Caption1>, status: "" }
            })
            :
            tempTableData.push({
              id: val.id,
              checkbox: "hide",
              category: {
                label: <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                  <Button appearance="transparent" size="small">  {val.Category} </Button>
                </Tooltip>, id: `${i}`
              },
              subcategory: { label: <Caption1> {val.subcategory} </Caption1>, status: "" },
              name: { label: <Caption1> {val.MetricDesc} </Caption1> },
              url_pattern: { label: <Caption1> {val.UrlPatters != null ? val.UrlPatters : "-"} </Caption1> },
              desktop_pattern: { label: <Caption1> {val.SpecificInfo} </Caption1> },
              attached_on: { label: <Caption1> {convertUTCToReadableFormat(val.attachedOn)} </Caption1> },
              attached_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.attachedOn, userTimeZone)} </Caption1> },
              attach_modified: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
              attach_modified_timezoned: { label: <Caption1> {val.attachModified ? new Date(val.attachModified * 1000).toLocaleString() : "-"} </Caption1> },
              status: { label: <Caption1> {status} </Caption1>, status: "" }
            })
        }
      });


    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);

    setTimeout(() => {
      final_data !== undefined && final_data !== null && setLoading(false);
    }, 500);
  }, [final_data, permissions, final_data1]); // data table values append code ends here

  console.log("tableData========>", tableData);
  useEffect(() => {
    !overlayOpen && setOverlayName('');
    console.log("Overlay Name: ", overlayName);
  }, [overlayOpen]);

  useEffect(() => {
    contextValue.setSelectedRowIdInTable([]);
  }, []);

  useEffect(() => {
    contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
  }, [contextValue.selectedRowIdInTable]);

  useEffect(() => {
    const pageNo = (currentPageNo - 1) * 50;

    const props: any = {
      data: final_data1,
      func: set_final_data1,
      searchVal: searchVal,
      pageNo: pageNo,
      setTotalPages: setTotalPages,
      setTotalRecords: setTotalRecords,
      isFilter: isfilter,
      setIsFilter: setIsFilter,
      isRefresh: isRefresh,
      setRefresh: setIsRefresh,
      setRefreshToast: setRefreshToast,
      filterArray: filterArray,
      exportBtnClicked: exportBtnClicked,
      setExportBtnClicked: setExportBtnClicked,
      setExportDetails: setExportDetails,
      tenant: tenantName,
      assignmentType: 'default_dart',
      loading: loading,
    }

    Remediation_func(props);
  }, [isRefresh /*, searchVal, currentPageNo, isfilter, filterArray, exportBtnClicked*/])

  console.log("exportDetails", exportDetails)
  return (
    <FullScreen handle={handle} className="fullScreenBackgroundColor">
      <StackItem grow shrink style={BreadcrumbsBorder}>
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          <StackItem grow shrink>
            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
              <StackItem><Text></Text></StackItem>
              <StackItem grow shrink>
                  <Breadcrumbs 
                      items={[
                        { name: "Manage", link: "/home" },
                        { name: "Devices", link: "/manage/devices/overview" },
                        { name: "Data Collection", link: "#" }
                      ]} 
                    />
              </StackItem>
            </Stack>
          </StackItem>
        </Stack>
      </StackItem>
      <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
        <StackItem style={DynamicBoxingCSS}> {/* pages code starts here */}
          <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
            <Stack style={DynamicBoxingCSS}>
              <FluentProvider style={heightResponsive} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal> {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={DevicesPages("Data Collection")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem style={wraperStyle}>
                        <StackItem>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <StackItem>
                              <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Name"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0}/>
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn={
                                  <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <Filter20Filled {...(loading || tableData.length === 0 ? secondaryIcon : primaryIcon)} />
                                      <Body1> Filter </Body1>
                                    </Stack>
                                  </MenuButton>
                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                  <Divider />
                                  <MenuList>
                                    <Stack tokens={{ childrenGap: 5 }}>
                                      <StackItem> <Text></Text> </StackItem>
                                      <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                      <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                      <StackItem> <Divider /> </StackItem>
                                      <StackItem> <Caption1> Value </Caption1> </StackItem>
                                      {(dropDownValue1 == "Subcategory" || dropDownValue1 == "Name") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {(dropDownValue1 == "Desktop Binaries" || dropDownValue1 == "Url Patterns") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                      {/* {dropDownValue1 == "Status" && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />} */}
                                      {(dropDownValue1 === "Status") && <DropdownComponent optionData={isStatus} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      {dropDownValue1 == "Category" && <DropdownComponent optionData={columns2} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                      <StackItem> <Divider /> </StackItem>
                                      <Stack tokens={{ childrenGap: 10 }} horizontal>
                                        <StackItem>
                                          <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                            disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                            <Caption1> Apply </Caption1>
                                          </Button>
                                        </StackItem>

                                        <StackItem>
                                          <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                            <Caption1> Cancel </Caption1>
                                          </Button>
                                        </StackItem>
                                      </Stack>
                                    </Stack>
                                  </MenuList>
                                </>} />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>

                          <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 0px' }}>
                            <StackItem>
                              {filterArray.length > 0 && (
                                <Stack horizontal wrap>
                                  {filterArray.map((item, index) => (
                                    <Button shape="circular" size="small">
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                        <StackItem>
                                          <Stack tokens={{ childrenGap: 1 }}>
                                            <StackItem><Text></Text></StackItem>
                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                          </Stack>
                                        </StackItem>
                                      </Stack>
                                    </Button>
                                  ))}
                                </Stack>
                              )}
                            </StackItem>

                            <StackItem disableShrink>
                              {(tableData.length > 0 && !loading) && (
                                totalRecords > 0 &&
                                <Caption1>
                                  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                </Caption1>
                              )}
                            </StackItem>
                          </Stack>
                        </StackItem>
                        <InfoBar showSpaces={true} title={"Attach or detach configuration to collect data from all devices or specific device classifications. "} />
                      </StackItem>
                      {!saveBtnClicked && <App_Monitored_Func dropDownValue1={dropDownValue1} dropDownValue2={dropDownValue2} isFilter={isfilter} filterArray={filterArray} set_final_data1={set_final_data1} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setDeleteDisabled={setDeleteDisabled} deleteAppMonitored={deleteAppMonitored} setDeleteAppMonitored={setDeleteAppMonitored} setOverlayOpen={setOverlayOpen} setFormData={setFormDataBasic} formdata={formDataBasic} overlayName={overlayName} saveBtnClicked={saveBtnClicked} setsaveBtnClicked={setSaveBtnClicked} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} setExportDetails={setExportDetails} deviceName={deviceName} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} /* setOverlayOpen={setOverlayOpen} */ loading={loading} setRecordState={setRecordState} setRecordTotalPages={setRecordTotalPages} />}
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? <DataTable tableData={tableData} columns={tableColumnsData} /> : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                      {/* {isBinaries && <Data_Collection_func setBinaries={setBinaries} isBinaries={isBinaries} />} */}
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
              <OverLay isNavBtn={true} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} saveBtnFunc={setSaveBtnClicked} overlayData={monitoredOverLayData} handleOutsideButton={handleOutsideButton} />
              {saveBtnClicked && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName == '') ? "Monitored App Deleted Successfully" : overlayName == 'addMonitoredApp' ? "New Monitoring App Added Successfully" : "Edited App Monitor Successfully"} footer="" />}
              {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
              {deleteAppMonitored && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={"Monitored App Deleted Successfully"} footer="" />}
            </Stack>
          </FluentProvider>
        </StackItem>
        <StackItem><Text></Text></StackItem>
      </Stack>
    </FullScreen>
  );
};